import React from 'react';
import { FormControlLabel, Radio, RadioGroup, Checkbox } from '@material-ui/core';
import ImagePicker from '../image-picker/Image-Picker';
import './Media-Selector.scss';
import CustomUiBuilderTextField from '../../form-controls/custom-ui-builder-text-field/Custom-UI-Builder-Text-Field';
import { isEmpty } from 'lodash';

const MediaSelector = (props) => {
  const {
    groupId,
    titleH2,
    height,
    width,
    handleTabData,
    activeTabContent,
    hasError,
    isSwapEnabled,
    ratio,
    matrix,
    title = '',
    isCustom = false,
    setIsSwapEnabled = () => {},
  } = props;

  return (
    <div className='col-md-12 redirect-selector mb-3'>
      <div className='row align-items-center mb-4 mt-3'>
        <div className='col-md-12'>
          <RadioGroup
            row
            aria-label='statusValue'
            onChange={(e) =>
              !isCustom
                ? handleTabData(e.target.value !== 'image', activeTabContent, 'isVideo')
                : handleTabData(
                    e.target.value !== 'image',
                    activeTabContent,
                    'isVideo',
                    'outerData',
                  )
            }
            value={!activeTabContent?.isVideo ? 'image' : 'video'}
            className='document-type'
            name='row-radio-buttons-group'
          >
            <FormControlLabel
              value='image'
              control={<Radio color='primary' />}
              label='Image'
              className='me-5'
            />
            <FormControlLabel
              value='video'
              control={<Radio color='primary' />}
              label='Video'
              className='ms-5'
            />
          </RadioGroup>
        </div>
        {!activeTabContent?.isVideo && (
          <div className='col-md-12 mt-4'>
            <ImagePicker
              key={activeTabContent?.id}
              groupId={groupId}
              titleH2={titleH2}
              title={title || ''}
              ratio={ratio}
              height={height}
              width={width}
              matrix={matrix}
              onImageSelect={(e) =>
                !isCustom
                  ? handleTabData(e, activeTabContent, 'imgURL')
                  : handleTabData(e, activeTabContent, 'imgURL', 'outerData')
              }
              setIsSwapEnabled={setIsSwapEnabled}
              imgURL={activeTabContent?.imgURL}
              error={!activeTabContent?.imgURL && !isSwapEnabled && hasError('imgURL')}
              shadowOverlay={activeTabContent?.shadowOverlay}
              onShadowOverlaySelect={(e) =>
                !isCustom
                  ? handleTabData(e, activeTabContent, 'shadowOverlay')
                  : handleTabData(e, activeTabContent, 'shadowOverlay', 'outerData')
              }
            />
          </div>
        )}
        {activeTabContent?.isVideo && (
          <>
            <div className='col-md-12'>
              <CustomUiBuilderTextField
                label='Video URL'
                required={true}
                className='col-md-12 mt-3'
                value={activeTabContent?.videoURL || ''}
                onChangeInput={(e) =>
                  !isCustom
                    ? handleTabData(e.target.value, activeTabContent, 'videoURL')
                    : handleTabData(e.target.value, activeTabContent, 'videoURL', 'outerData')
                }
                maxLength={1000}
                isAdornment={true}
                endAdornment={true}
                errorType={!isSwapEnabled && hasError('videoURL', true)}
                error={!isSwapEnabled && hasError('videoURL')}
              />
            </div>
            <div className='d-flex justify-content-between'>
              <div className='px-2 image-details'>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={activeTabContent?.shadowOverlay}
                      onChange={(e) =>
                        !isCustom
                          ? handleTabData(e.target.checked, activeTabContent, 'shadowOverlay')
                          : handleTabData(
                              e.target.checked,
                              activeTabContent,
                              'shadowOverlay',
                              'outerData',
                            )
                      }
                    />
                  }
                  label={'Shadow Overlay'}
                  className='media-option'
                />
              </div>
              {!isEmpty(activeTabContent?.videoURL) && (
                <div
                  onClick={() =>
                    !isCustom
                      ? handleTabData('', activeTabContent, 'videoURL')
                      : handleTabData('', activeTabContent, 'videoURL', 'outerData')
                  }
                  className='px-2 pt-2 pointer image-video-details'
                >
                  Remove Video
                </div>
              )}
            </div>
            <div className='d-flex justify-content-start'>
              <div className='px-2 image-details'>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={activeTabContent?.loopPlayBack}
                      onChange={(e) =>
                        !isCustom
                          ? handleTabData(e.target.checked, activeTabContent, 'loopPlayBack')
                          : handleTabData(
                              e.target.checked,
                              activeTabContent,
                              'loopPlayBack',
                              'outerData',
                            )
                      }
                    />
                  }
                  label={'Loop Playback'}
                  className='media-option'
                />
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default MediaSelector;
